import { types } from "../types/types";

const initialState = {
  generalTableData: [],
};

export const generalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getGeneralTableData:
      return {
        ...state,
        generalTableData: [...action.payload],
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
